import { Link } from 'react-router-dom';

interface FirstPostCardProps {
  post: {
    id: string;
    title: string;
    slug: string;
    description: string;
    thumbnail: string;
    category: string | string[];
    date: string;
  };
}

export const FirstPostCard = ({ post }: FirstPostCardProps) => {
  const categories = typeof post.category === 'string' 
    ? post.category.split(', ') 
    : post.category;
  
  const mainCategory = categories[0];

  // Generate srcset for responsive images
  const generateSrcSet = (url: string) => {
    if (!url) return '';
    const baseUrl = url.split('?')[0];
    return `
      ${baseUrl}?width=400&quality=75 400w,
      ${baseUrl}?width=700&quality=75 700w,
      ${baseUrl}?width=1000&quality=75 1000w
    `.trim();
  };

  return (
    <article className="new-post-card glass-morphism rounded-2xl overflow-hidden shadow-sm scroll-reveal" role="article" style={{ animationDelay: `${Math.random() * 0.3}s` }}>
      <div className="relative overflow-hidden aspect-video">
        <img 
          src={post.thumbnail} 
          srcSet={generateSrcSet(post.thumbnail)}
          sizes="(max-width: 640px) 400px, (max-width: 1024px) 700px, 1000px"
          alt={post.title} 
          className="w-full h-full object-cover transition-transform duration-300 hover:scale-110" 
          fetchPriority="high"
          width="700"
          height="400"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent">
          <span className="absolute bottom-4 left-4 px-3 py-1 bg-gradient-to-r from-blue-500 to-purple-500 text-white text-sm rounded-full">
            {mainCategory}
          </span>
          <span className="absolute bottom-4 right-3 px-3 py-1 text-white text-sm rounded-full">
            {new Date(post.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
          </span>
        </div>
      </div>
      <div className="p-6">
        <h3 className="text-xl font-bold mb-3 hover:text-blue-500 transition-colors line-clamp-2">
          <Link to={`/posts/${post.slug}`}>{post.title}</Link>
        </h3>
        <p className="text-gray-600 mb-4 line-clamp-3">{post.description}</p>
        <div className="flex flex-wrap gap-2">
          {categories.filter((cat: string) => cat !== mainCategory).map((cat: string, idx: number) => (
            <span key={idx} className="text-sm text-gray-500">#{cat}</span>
          ))}
        </div>
      </div>
    </article>
  );
};
